module.exports = __webpack_public_path__ + "e0b48985d7391b38cf4f18638031f915.jpg";